
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "Contacts",

  computed: {
    vars: function () {
      return this.$store.state?.appState?.vars || {}
    },

    phoneNumbersLinks: function () {
      const _phones = [];
      const mainPhone = this.vars?.['Телефон'] || '';
      const additionalPhones = this.vars?.['Дополнительные телефоны'].split(',') || '';
      if (mainPhone) {
        _phones.push(this.$phoneFormat(mainPhone));
      }
      if (additionalPhones) {
        additionalPhones.forEach((item) => {
          _phones.push(this.$phoneFormat(item.trim()));
        });
      }
      return _phones;
    },

    information: function () {
      let list = [];

      if (this.vars['Телефон']) {
        list.push({
          title: "Телефон (бесплатно по РФ):",
          value: this.$phoneFormat(this.vars['Телефон']),
          icon: require("~/assets/img/svg/common/phone-primary.svg"),
          link: `tel:${this.$phoneFormat(this.vars['Телефон'])}`,
          links: this.phoneNumbersLinks || [],
          className: "zphone"
        })
      }
      if (this.vars['Время работы']) {
        list.push({
          title: "Сотрудники отдела логистики готовы принять ваш заказ:",
          value: this.vars['Время работы'],
          icon: require("~/assets/img/svg/common/union-primary.svg"),
          className: ""
        })
      }
      if (this.vars['Почтовый адрес']) {
        list.push({
          title: "Электронная почта:",
          value: this.vars['Почтовый адрес'],
          icon: require("~/assets/img/svg/common/email-primary.svg"),
          link: `mailto:${this.vars['Почтовый адрес']}`,
          className: ""
        })
      }
      if (this.vars['Полный адрес']) {
        list.push({
          title: "Адрес головного офиса:",
          value: this.vars['Полный адрес'],
          icon: require("~/assets/img/svg/common/pin-primary.svg"),
          className: ""
        })
      }

      return list
    },

    addressShop: function () {
      return this.vars?.['Полный адрес'] || ""
    },
    yandexMap: function () {
      return this.vars?.['Яндекс карты офиса продаж']
    }
  },

  components: {
    Map: () => import("./components/ContactsBlock/Map")
  }
})
